.app-article-listing {
    @include padding-direction(top, 16);
    @include padding-direction(bottom, 64);

    .col-12 {

        &:last-of-type {
            padding-bottom: 0;
        }

        app-article {
            .article-card {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                height: 100%;
                @include padding-direction(top, 25);
                @include padding-direction(bottom, 24);
                border-top: 1px solid #EFEFEF;

                .mobile-wrapper {
                    display: flex;
                    height: 100%;
                    align-items: center;

                    .mobile-right {
                        display: none;
                    }
                }

                .card-image {
                    width: 388px;
                    min-width: 388px;
                    height: 100%;
                    max-height: 219px;
                    @include margin-direction(right, 40);

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .card-content {

                    .tags {
                        display: inline-block;
                        color: $gray-dark;
                        @include text-size(14);
                        @include line-height(22);
                        @include margin-direction(bottom, 12);
                    }

                    .card-title {
                        display: block;
                        font-family: $font-family-primary-bold;
                        color: $gray-dark;
                        @include text-size(20);
                        @include line-height(24);
                        @include margin-direction(bottom, 16);
                        text-decoration: underline;

                        &:hover,
                        &:focus {
                            text-decoration: none;
                        }
                    }

                    .author {
                        display: block;
                        color: $gray-dark;
                        @include text-size(16);
                        @include line-height(24);
                        @include margin-direction(bottom, 20);
                    }

                    p {
                        color: $gray-dark;
                        @include text-size(14);
                        @include line-height(22);
                        @include margin-direction(bottom, 21);
                    }

                    a.arrow-link__underline {
                        color: $quinary;
                        margin-bottom: 0;
                    }
                }
            }
        }
    }


    @include media-breakpoint-down(xl) {
        @include padding-direction(top, 40);
        @include padding-direction(bottom, 40);

        .col-12 {

            app-article {
                .article-card {
                    flex-direction: column;

                    .mobile-wrapper {

                        .mobile-right {
                            display: flex;
                            flex-direction: column;
                            width: 100%;

                            .tags {
                                display: inline-block;
                                color: $gray-dark;
                                @include text-size(12);
                                @include line-height(20);
                                @include margin-direction(bottom, 4);
                            }

                            .card-title {
                                display: block;
                                font-family: $font-family-primary-bold;
                                color: $gray-dark;
                                @include text-size(16);
                                @include line-height(24);
                                @include margin-direction(bottom, 12);
                                text-decoration: underline;

                                &:hover,
                                &:focus {
                                    text-decoration: none;
                                }
                            }

                            .author {
                                display: block;
                                color: $gray-dark;
                                @include text-size(12);
                                @include line-height(20);
                                @include margin-direction(bottom, 14);
                            }
                        }
                    }

                    .card-image {
                        width: 100%;
                        min-width: 100px;
                        max-width: 150px;
                        height: auto;
                        min-height: 100px;
                        @include margin-direction(right, 16);
                    }

                    .card-content {

                        .desktop-right {
                            display: none;
                        }



                        p {
                            @include margin-direction(top, 16);
                            @include text-size(12);
                            @include line-height(20);
                        }

                        a.arrow-link__underline {
                            color: $gray-dark;
                        }

                    }
                }
            }
        }

    }
}